import { hashKey, useQuery } from '@tanstack/react-query';

import { IDeclarationsCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDeclarationsMeta = (criteria: IDeclarationsCriteria) =>
  useQuery({
    queryKey: ['declarations-meta', hashKey([criteria])],
    queryFn: async (): Promise<{ total: number }> => {
      const { filters, sorting, pagination } = criteria;
      try {
        const { metadata } = await request({
          path: `declarations/declaration-list-metadata`,
          method: 'POST',
          authenticate: true,
          dataObject: {
            criteria: {
              filters,
              sorting,
              pagination,
            },
          },
        });
        return metadata;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarations meta');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
